import React from 'react';
import { money } from "../../utils/strings";
import moment from 'moment';

const formatValue = (initialValue, annualReturn, years) => {
  console.log(initialValue, annualReturn, years)
  const totalDollarValue = initialValue * Math.pow(1 + annualReturn / 100, years);
  console.log(totalDollarValue)
  return money(totalDollarValue, 0);
};

const calculateAgeAtEvent = (currentAge, currentDate, eventDate) => {
  return currentAge + eventDate.diff(moment(currentDate), 'years');
};

const JourneyPath = ({ stages, onEditStage, clientMeta, annualReturn, maxWidth = 800 }) => {
  const startDate = moment();
  const maxFutureDate = stages.reduce((maxDate, stage) => {
    return stage.date.isAfter(maxDate) ? stage.date : maxDate;
  }, startDate);

  const totalDays = maxFutureDate.diff(startDate, 'days');
  const width = Math.max(totalDays * 10, maxWidth); // Dynamic width based on maxWidth

  const stagePositions = stages.map((stage, index) => {
    const timeDiff = stage.date.diff(startDate, 'days');
    const x = (timeDiff / totalDays) * (maxWidth - 100) + 50; // Adjusting to use full maxWidth
    const y = 100 * (index % 2 === 0 ? 1 : 2);
    return { ...stage, x, y };
  });

  const renderShape = (shape, x, y, color) => {
    switch (shape) {
      case 'square':
        return <rect x={x - 10} y={y - 10} width="20" height="20" fill={color} />;
      case 'triangle':
        return (
          <polygon
            points={`${x},${y - 10} ${x - 10},${y + 10} ${x + 10},${y + 10}`}
            fill={color}
          />
        );
      case 'heart':
        return (
          <path
            d={`M${x} ${y - 10} 
              C${x - 10} ${y - 20}, ${x - 20} ${y - 5}, ${x} ${y + 10} 
              C${x + 20} ${y - 5}, ${x + 10} ${y - 20}, ${x} ${y - 10}`}
            fill={color}
          />
        );
      case 'plus':
        return (
          <>
            <rect x={x - 3} y={y - 10} width="6" height="20" fill={color} />
            <rect x={x - 10} y={y - 3} width="20" height="6" fill={color} />
          </>
        );
      case 'check':
        return (
          <polyline
            points={`${x - 10},${y} ${x - 2},${y + 8} ${x + 10},${y - 10}`}
            fill="none"
            stroke={color}
            strokeWidth="2"
          />
        );

      case 'flag':
        const stripeHeight = 2;
        const stripeWidth = 10;
        const flagWidth = 20;
        const flagHeight = 20;
        const stripes = [];

        for (let i = 0; i < flagHeight; i += stripeHeight) {
          stripes.push(
            <rect
              key={`stripe-${i}`}
              x={x + 2}
              y={y - 10 + i}
              width={flagWidth}
              height={stripeHeight}
              fill={i % 4 === 0 || i % 4 === 1 ? color : 'white'}
            />
          );
        }

        return (
          <g>
            <rect x={x - 2} y={y - 10} width="4" height="20" fill={color} />
            {stripes}
          </g>
        );
      default:
        return <circle cx={x} cy={y} r="10" fill={color} />;
    }
  };

  const createSineWavePath = (positions) => {
    let path = '';
    for (let i = 0; i < positions.length - 1; i++) {
      const startX = positions[i].x;
      const startY = positions[i].y;
      const endX = positions[i + 1].x;
      const endY = positions[i + 1].y;
      const midX = (startX + endX) / 2;
      const amplitude = 20; // Adjust amplitude for the hump height

      path += `M ${startX},${startY} 
               Q ${midX},${startY - amplitude} ${endX},${endY} `;
    }
    return path;
  };

  return (
    <svg width={width < maxWidth ? width : maxWidth} height="400px" style={{ display: 'block', margin: '0 auto' }}>
      <path
        d={createSineWavePath(stagePositions)}
        fill="none"
        stroke="blue"
        strokeWidth="3"
        strokeDasharray="5,5" // Dotted line
      />
      {stagePositions.map((pos, index) => (
        <g key={index} onClick={() => onEditStage(pos)} style={{ cursor: 'pointer' }}>
          {renderShape(pos.shape, pos.x, pos.y, pos.color)}
          {index % 2 === 0 ? (
            <>
              <text x={pos.x} y={pos.y - 55} textAnchor="middle" fontSize="12" fontWeight="600" fontFamily="var(--font-family)">
                {pos.objective}
              </text>
              <text x={pos.x} y={pos.y - 40} textAnchor="middle" fontSize="11" fontWeight="600" fontFamily="var(--font-family)">
                {formatValue(clientMeta.investments, annualReturn, pos.date.diff(startDate, 'years'))}
              </text>
              <text x={pos.x} y={pos.y - 25} textAnchor="middle" fontSize="10" fontWeight="600" fontFamily="var(--font-family)">
                Age: {calculateAgeAtEvent(clientMeta.age, startDate, pos.date)}
              </text>
            </>
          ) : (
            <>
              <text x={pos.x} y={pos.y + 25} textAnchor="middle" fontSize="12" fontWeight="600" fontFamily="var(--font-family)">
                {pos.objective}
              </text>
              <text x={pos.x} y={pos.y + 40} textAnchor="middle" fontSize="11" fontWeight="600" fontFamily="var(--font-family)">
                {formatValue(clientMeta.investments, annualReturn, pos.date.diff(startDate, 'years'))}
              </text>
              <text x={pos.x} y={pos.y + 55} textAnchor="middle" fontSize="10" fontWeight="600" fontFamily="var(--font-family)">
                Age: {calculateAgeAtEvent(clientMeta.age, startDate, pos.date)}
              </text>
            </>
          )}
        </g>
      ))}
    </svg>
  );
};

export default JourneyPath;
